module.exports = "/_next/static/images/Hero@2x-65997089ec59e5a1e8dd3ba90193847a.webp";